/*
 * Jira Ticket:
 * Created Date: Wed, 1st Apr 2020, 15:02:53 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getOneOrganisationQuery = gql`
  query Organisation($id: ID!) {
    data: Organisation(id: $id) {
      id
      name
      statistics {
        numberOfProjects
        numberOfSites
        numberOfUsers
      }
      contact {
        name
        phone
        email
        position
      }
      isFreeTrialUsed
      subscription {
        subscriptionTier {
          id
          capabilities {
            id
            enabled
            __typename
          }
        }
      }
      checklistRequired
      projectAccess
      role
      addressLine1
      addressLine2
      city
      postCode
      country
    }
  }
`;
